import {DefaultDataService, DefaultDataServiceConfig, Logger, QueryParams} from "@ngrx/data";
import {HttpClient} from "@angular/common/http";
import {CustomizeHttpUrlGenerator} from "../url/customizeHttpUrlGenerator";
import {Observable} from "rxjs";
import {UrlHelper} from "../url/urlHelper";
import {defaultDataServiceConfig} from "../defaultDataServiceConfig";
import {map} from "rxjs/operators";
import {PageHelper} from "../pagination/pageHelper";

export class DefaultDataservice<T> extends DefaultDataService<T> {
    constructor(entityName: string, http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator, logger: Logger, config: DefaultDataServiceConfig) {
        super(entityName, http, httpUrlGenerator, config);
    }

    get httpClient(): HttpClient {
        return this.http;
    }

    getWithQuery(params: string | QueryParams): Observable<T[]> {
        return this.http.get(UrlHelper.formatUrl(this.httpUrlGenerator.collectionResource(this.entityName, defaultDataServiceConfig.root), params))
            .pipe(
                map((data: any) => {
                    return PageHelper.convertRestPageToStorePage(data);
                })
            );
    }


    getOneWithQuery(path: string, params?: string | QueryParams): Observable<T> {
        const formattedPath = this.buildPath(false, undefined, path);
        return this.http.get<T>(UrlHelper.formatUrl(formattedPath, params));

    }

    buildPath(plural: boolean, id: string | number, path: string) {
        let fullPath = plural ? this.entitiesUrl : this.entityUrl;
        if (id) {
            fullPath += id;
        }

        if (path) {
            fullPath += (path.startsWith('/') || fullPath.endsWith('/') ? path : ('/' + path));
        }

        // console.logByType'fullPath ' + fullPath + ' ' + path + ' ' + id);
        return fullPath;
    }

    executeUpdate(id: number | string, path: string, payload: any): Observable<T> {
        return this.execute('PUT', this.buildPath(false, id, path), payload);
    }

    executeCreate(payload: any, path?: string): Observable<any> {
        return this.execute('POST', this.buildPath(false, undefined, path), payload);
    }

    executeDeleteWithQueryParams(id: number | string, queryParams: string): Observable<void> {
        return this.execute('DELETE', this.buildPath(false, id, undefined) + queryParams);
    }

    getEntityUrl(): string {
        return this.entityUrl;
    }
}